import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/app/require-permission';
import { BarberPage } from './barber-page';
import { ServicesPage } from './services-page';
import { TeamPage } from './team-page';

export const appRoutes: RouteObject[] = [
  {
    path: 'servicos',
    element: (
      <RequirePermission anyOf={['catalog.manage']}>
        <ServicesPage />
      </RequirePermission>
    ),
  },
  {
    path: 'equipe',
    element: (
      <RequirePermission anyOf={['catalog.manage', 'commissions.manage']}>
        <TeamPage />
      </RequirePermission>
    ),
  },
  {
    path: 'equipe/:id',
    element: (
      <RequirePermission anyOf={['catalog.manage', 'commissions.manage']}>
        <BarberPage />
      </RequirePermission>
    ),
  },
];
